import React from 'react';
import './TrustMarker.css';

const paymentImgs = [
  'https://jsak.mmtcdn.com/bus_cdn_rnw/static/images/Bus/seo/master_card.png',
  'https://jsak.mmtcdn.com/bus_cdn_rnw/static/images/Bus/seo/UPI.png',
  'https://jsak.mmtcdn.com/bus_cdn_rnw/static/images/Bus/seo/visa.png',
  'https://jsak.mmtcdn.com/bus_cdn_rnw/static/images/Bus/seo/rupay.png'
];

const TrustMarker = ({ rtcAcronym }) => {
  return (
    <div className="markerContainer">
      <div className="titleContainer">
        <div>
          <img
            src="http://imgak.mmtcdn.com/pwa_v3/pwa_hotel_assets/header/logo@2x.png"
            className="mmtLogo"
          />
        </div>
        <div className="titleText">
          Official <span className="latoBold">{rtcAcronym}</span> booking
          partner
        </div>
      </div>

      <div className="containerPadding">
        <div className="makeFlex lineMargin">
          <div className=" appendRight15">
            <img
              className="imgContainer"
              src={`https://jsak.mmtcdn.com/bus_cdn_rnw/static/images/Bus/seo/headphone.png`}
              alt={'headphones'}
            />
          </div>
          <div>
            <span className="latoBold appendRight5">24 X 7</span>
            Customer service (Call & Chat)
          </div>
        </div>

        <div className="makeFlex lineMargin">
          <div className="appendRight15">
            <img
              className="imgContainer"
              src={`https://jsak.mmtcdn.com/bus_cdn_rnw/static/images/Bus/seo/user_group.png`}
              alt={'users'}
            />
          </div>
          <div>
            <span className="latoBold appendRight5">36 Mn+</span>
            users trust us
          </div>
        </div>

        <div className="makeFlex lineMargin">
          <div className="appendRight15">
            <img
              className="imgContainer"
              src={`https://jsak.mmtcdn.com/bus_cdn_rnw/static/images/Bus/seo/seat.png`}
              alt={'seats'}
            />
          </div>
          <div className="latoBold">Assured Seat of your choice</div>
        </div>

        <div className="makeFlex lineMargin">
          <div className="appendRight15">
            <img
              className="imgContainer"
              src={`https://jsak.mmtcdn.com/bus_cdn_rnw/static/images/Bus/seo/ticket.png`}
              alt={'ticket'}
            />
          </div>
          <div>
            <span className="latoBold appendRight5">2,00,000+</span>
            bookings per day
            <br />
            World's largest online bus ticket booking platform
          </div>
        </div>

        <div className="makeFlex lineMargin">
          <div className="appendRight15">
            <img
              className="imgContainer"
              src={`https://jsak.mmtcdn.com/bus_cdn_rnw/static/images/Bus/seo/shield.png`}
              alt={'shield'}
            />
          </div>
          <div>
            <div>Secured and Verified payment options</div>
            <div>
              {paymentImgs.map(imgLink => {
                return (
                  <span>
                    <img className="paymentImg" src={imgLink} />
                  </span>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustMarker;
